import React         from 'react';
import pic_about_1   from '../pictures/MassiveChain.webp';
import pic_about_2   from '../pictures/OldChain.webp';
import  MyCard       from '../components/MyCardV2.jsx';
import { useState }  from "react";
import landscape     from './about.module.css';
import portrait      from './portrait.module.css';

//import './landscape.css';

import TextBlock     from '../components/textBlock.jsx';
import Newspaper     from '../components/Newspaper.jsx';
import Paper         from '../components/Paper.jsx';
import {Context}     from '../services/context.js';
import { Helmet }    from 'react-helmet';
import cx            from 'classnames';

const cx_header     = cx({[portrait.header]:  Context.portrait, [landscape.header]: !Context.portrait});
const cx_text       = cx({[portrait.text]:    Context.portrait, [landscape.text]:   !Context.portrait});
const cx_ul         = cx({[portrait.ul]:      Context.portrait, [landscape.ul]:     !Context.portrait});
const cx_li         = cx({[portrait.li]:      Context.portrait, [landscape.li]:     !Context.portrait});
const cx_text_wide  = cx([landscape.text_wide])

const currentYear  = new Date().getFullYear();
const name         = ['Blockchain Systems Pte. Ltd. '];       // Replace with your name
const location     = ['Singapore'];                           // Replace with your actual location
const contactEmail = ['info@blockchainsystems.vip'];          // Replace with your contact email

  const text_1  = [{header: <p className={cx_header} >Blockchain Systems</p>},
  {text: <p className={cx_text}>
    Blockchain Systems Pte. Ltd. in Singapore is a privately owned hardware and software company 
    with know-how in cryptography, electronics and chip design, Linux kernel programming and related fields. 
    The company was founded in 2018 exclusively for the continuing development and marketing of the Back-Step Blockchain invention. 
    <b> Encryption Technology Pte. Ltd.</b> is the sister company with professional know-how in the field of network encryption at the government level. 
    ET produces the hardware for the various versions of the Back-Step Blockchain generator. 
  </p>}];

  const text_2  = [{header: <p className={cx_header} >Our Business</p>},
  {text: <p className={cx_text}>
    We provide the <strong>hardware modules</strong> to build Back-Step Blockchain servers. This hardware is intended for companies who create customized blockchain applications 
    for their customers or off the shelf applications based on Back-Step Blockchain.
    Beside the pure hardware we provide the <strong>APIs</strong> required by software developers to communicate with the Back-Step Generator. Sample software drivers and entry-level 
    applications are provided to our customers and partners on request.
  </p>},

  {text: <p className={cx_text}>
   
   Besides the hardware we provide <strong>Trust.it</strong>, a web service based on the entry level hardware module. See more on the product page under Trust.it. 
  </p>},

  {text: <p className={cx_text}>
    Finally, we offer <strong>licenses</strong> for customers who want to integrate Back-Step Blockchain into their products, like black boxes or smartphones.  
  </p>}];

const text_3  = [{header:  <p className={cx_header} >Impressum</p>},
  {text: <p className={cx_text}>
    Impressum |  Back-Step Blockchain | Owner: {name} {location} (CRN: 201832149D) | Contact: {contactEmail} | Copyright &copy; {currentYear} by {name}.
    All rights reserved.
    The Back-Step Blockchain and its technology are patented.
  </p>},

  {text: 
    <ul className={cx_ul}> 
      <li className={cx_li}> US 11,902 447 B2</li>
      <li className={cx_li}> EU 3 871 368.B1</li>
      <li className={cx_li}> Japan 7208455</li>
      <li className={cx_li}> India 516737</li>
      <li className={cx_li}> Singapore 11202011414Y</li>
      <li className={cx_li}> China 2019800775912</li>
      <li className={cx_li}> Korea 10-2021-7011872</li>
      <li className={cx_li}> Israel 282816</li>   
      <li className={cx_li}> UK pending</li>
    </ul>
  },
  {text: <p className={cx_text}>
    Unauthorized use, duplication, or distribution of this material without 
    explicit permission from the patent holder is strictly prohibited.</p>}]
  
export class About extends React.Component 
{
    //------------------------------------------------------------------
    //  Constructor
    //------------------------------------------------------------------
    constructor(props) 
    {
      super(props);
      this.component= "";
      this.state = {content_disabled: false}
    }  
    

    componentDidMount()
    {
      //console.log('Component did mount in About Us');
      this.forceUpdate();
    };
   
    
    //------------------------------------------------------------------
    //
    //------------------------------------------------------------------
    changeVisible(mode)
    {
      this.setState({content_disabled:mode})
    }

    //-----------------------------------------------------------
    // rendering for portrait
    //-----------------------------------------------------------
    render()
    { 

      if (Context.portrait)
        {
          this.component = 
          <div className={portrait.backdrop}>

              <Helmet>
                <title>About page</title>
                <meta name="description" content="Explains Blockchain Systems " />
              </Helmet>

                <div className={portrait.title}>
                    About us...
                </div>

                <div className={cx_text}> 
                  < Paper textLines = {text_1}/> 
                </div>
  
                <div className={cx_text}>
                  <Paper  textLines = {text_2}/>
                </div>
  
                <div className={cx_text}>
                  <Paper  textLines = {text_3}/>
                </div>
              </div>
        }
        else
        {
        //-----------------------------------------------------------
        // rendering for landscape
        //-----------------------------------------------------------
         this.component = 
         <div className={landscape.backdrop} onMouseDown={()=>this.changeVisible(true)} onMouseUp={()=>this.changeVisible(false)} onContextMenu={(e) => e.preventDefault()}>

              <Helmet>
                <title>About page</title>
                <meta name="description" content="Impressum Blockchain Systems " />
              </Helmet>

              {! this.state.content_disabled &&
           
           <>
           <div className={landscape.title_location}>
             <div className={landscape.title_text}> 
             <p>Want to know more about us... </p>
             </div>
           </div>

              <div className={landscape.container}>
                <div className={cx_text}> 
                < Newspaper textLines = {text_1}/> 
                </div>

                <div className={cx_text}>
                  <Newspaper  textLines = {text_2}/>
                </div>

                <div className={cx_text_wide}>
                  <Newspaper  textLines = {text_3}/>
                </div>

              </div>
              </>
              }
            </div>

        }
      return this.component ;
    }
}
